module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"view":"View","search":"search","warnMessage":"Please remove a device before add a new one or drag it to replace"},"zh":{"view":"预览","search":"搜索","warnMessage":"请先移出一个设备再添加新设备或拖拽设备去替代"}}')
  delete Component.options._Ctor
}
